import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaNullDefinition } from './TypedDefinition'

export const SchemaNullPlugin = createSchemaPlugin(
  'Schema.Null',
  SchemaNullDefinition
)
